function Mail({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.02549 22.7499C4.43617 22.7499 3.93734 22.5458 3.529 22.1374C3.12067 21.7291 2.9165 21.2303 2.9165 20.641V7.35898C2.9165 6.76966 3.12067 6.27083 3.529 5.8625C3.93734 5.45417 4.43617 5.25 5.02549 5.25H22.9741C23.5635 5.25 24.0623 5.45417 24.4706 5.8625C24.8789 6.27083 25.0831 6.76966 25.0831 7.35898V20.641C25.0831 21.2303 24.8789 21.7291 24.4706 22.1374C24.0623 22.5458 23.5635 22.7499 22.9741 22.7499H5.02549ZM13.9998 14.6506L4.66647 8.68262V20.641C4.66647 20.7457 4.70013 20.8317 4.76745 20.899C4.83477 20.9663 4.92078 21 5.02549 21H22.9741C23.0788 21 23.1649 20.9663 23.2322 20.899C23.2995 20.8317 23.3331 20.7457 23.3331 20.641V8.68262L13.9998 14.6506ZM13.9998 12.8333L23.1537 6.99997H4.84597L13.9998 12.8333ZM4.66647 8.68262V6.99997V20.641C4.66647 20.7457 4.70013 20.8317 4.76745 20.899C4.83477 20.9663 4.92078 21 5.02549 21H4.66647V8.68262Z" />
    </svg>
  );
}

export default Mail;
